var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.tag,_vm._g({tag:"component",staticClass:"icon-button",attrs:{"data-microtip-position":"top","aria-label":_vm.tooltip,"role":_vm.tooltip !== undefined ? 'tooltip' : undefined}},_vm.$listeners),[_c('Icon',_vm._b({staticClass:"icon",style:({ color: `var(--color-${_vm.color}, #000)` })},'Icon',_vm.$attrs,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }